import CarAuditorPortalImg from "../../assets/images/car-auditor-portal-img.svg";
import LogoPortalImg from "../../assets/images/logo-portal-img.svg";
import FAQImage from "../../assets/images/faq-image.svg";
import ManageUserImg from "../../assets/images/manage-user-img.svg";

export const adminPortalCards = [
    {
      title: "How to use the Auditor Portal",
      text: "Simplify compliance and tracking",
      imageUrl: CarAuditorPortalImg,
      time: "5 minutes",
    },
    {
      title: "How to use the Customer Portal",
      text: "Simplify compliance and tracking",
      imageUrl: CarAuditorPortalImg,
      time: "5 minutes",
    },
    {
      title: "How to use the Logo Portal",
      text: "Handle logo approvals with ease",
      imageUrl: LogoPortalImg,
      time: "5 minutes",
    },
  ];
  
export const auditorPortalCards = [
    {
      title: "How to use the Auditor Portal",
      text: "Simplify compliance and tracking",
      imageUrl: CarAuditorPortalImg,
      time: "5 minutes",
    },
  ];
  
export const customerPortalCards = [
    {
      title: "How to use the Customer Portal",
      text: "Simplify compliance and tracking",
      imageUrl: CarAuditorPortalImg,
      time: "5 minutes",
    },
    {
      title: "How to use the Logo Portal",
      text: "Handle logo approvals with ease",
      imageUrl: LogoPortalImg,
      time: "5 minutes",
    },
  ];
  
export const otherPortalCards = [
    {
      title: "Submitting a FSC Logo Request",
      text: "Submitting a FSC Logo Request",
      imageUrl: FAQImage,
      time: "5 minutes",
      srcURL: "https://scribehow.com/embed/Submitting_a_FSC_Logo_Request__mxd2Nj3TRFap9DFDJIfBgQ"
    },
    {
      title: "Requesting a change to an existing request",
      text: "Requesting a change to an existing request",
      imageUrl: ManageUserImg,
      time: "5 minutes",
      srcURL: "https://scribehow.com/embed/Handling_a_change_request__o72j2vR0QsylWDOuopM2xA"
    },
    {
      title: "Multi User Support",
      text: "Multi User Support",
      imageUrl: ManageUserImg,
      time: "5 minutes",
      srcURL: "https://scribehow.com/embed/Multi-User_Support__lAr6rJbtQBiB6pVrSu8L9g"
    }
  ];
  